import { Utils } from './utils'
// import * as index from './index-utils'
// import * as contract from './contract-utils'
// import * as ix2044 from './ix2044-utils'
// import * as fibu from './fibu-utils'

// const utilFunctions = {
//     ...utils,
//     index,
//     contract,
//     ix2044,
//     fibu,
// }

export const utils = new Utils()
export default utils

// export default utilFunctions
